export enum HelperPopupType {
  Colors = 'layout',
  Options = 'options'
}
